import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { createUserApiError } from '../../../lib/createUserApiError';
import { RestAddressAttributes } from '../fragments.rest';
import { updateAddressesCache as update } from '../useAddressesQuery';
import { convertAddressAttributesToRestInput } from '../convertAddressAttributesToRestInput';
import {
  CREATE_ADDRESS_MUTATION,
  CreateAddressMutation,
  CreateAddressMutationVariables
} from './createAddressMutation.rest';

export const useCreateAddressMutation = () => {
  const [mutate, { loading, error }] = useMutation<
    CreateAddressMutation,
    CreateAddressMutationVariables
  >(CREATE_ADDRESS_MUTATION, {
    update
  });
  const userApiError = createUserApiError(error);

  const createAddress = useCallback(
    async (address: RestAddressAttributes) => {
      const result = await mutate({
        variables: { input: convertAddressAttributesToRestInput(address) }
      });
      return result.data?.createAddress.data;
    },
    [mutate]
  );

  return [createAddress, { loading, error: userApiError }] as const;
};
